import React, {Fragment} from 'react';
import {Form, Field} from 'react-final-form';
import {Popup, Text, Select} from '../../../components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import axios from 'axios';
import {connect} from 'react-redux';

function Sending_limits_update_popup(props){

  function onSubmit(params){axios.put('/api/email/smtp_logins/'+props.smtp_login.id+'/sending_limits', params).then(()=>{window.location.reload();})}

  return(
    <Form
      onSubmit={onSubmit}
      initialValues={{daily_limit:props.smtp_login.daily_limit, hourly_limit:props.smtp_login.hourly_limit, seconds_delay:props.smtp_login.seconds_delay}}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup handleClose={props.handleClose} accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}}  always_open title='Update sending limits' content={
          <div style={{width:'95vw', maxWidth:'600px', height:'400px'}}>
          <Grid container style={{marginTop:'10px'}}>
            <Grid item xs={12} style={{display:'flex', justifyContent:'center', alignItems:'center'}}><Typography variant='caption' style={{width:'calc(100% - 20px)', marginTop:'20px', marginBottom:'20px'}}>Sending limits are necessary to control the outflow of emails. Pending emails will be sent in order and following these limits. If you are getting flagged as SPAM or your email client has issued you a warning make sure to set very low limits.</Typography></Grid>
            <Grid item xs={12} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
              <Grid container>
                <Grid item xs={5}><div style={{width:'calc(100% - 60px)', position:'relative'}}><Text variant='outlined' size='small' title='Daily limit' name='daily_limit' type='number' min={0} max={500}/></div></Grid>
                <Grid item xs={7}><Typography variant='caption' style={{width:'calc(100% - 60px)'}}>We recommend to set # of daily emails between 100 and 400. Most email clients like Gmail and Outlook limit how many daily emails you can send</Typography></Grid>
                <Grid item xs={12}><hr/></Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} style={{marginTop:'30px', display:'flex', justifyContent:'center', alignItems:'center'}}>
              <Grid container>
                <Grid item xs={5}><div style={{width:'calc(100% - 60px)', position:'relative'}}><Text variant='outlined' size='small' title='Hourly limit' name='hourly_limit' type='number' min={0} max={150}/></div></Grid>
                <Grid item xs={7}><Typography variant='caption' style={{width:'calc(100% - 20px)'}}>Maximum allowed is 120 to avoid having your email client block us or flag your account. Gmail does not allow more than 500 hourly emails.</Typography></Grid>
                <Grid item xs={12}><hr/></Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} style={{marginTop:'30px', display:'flex', justifyContent:'center', alignItems:'center'}}>
              <Grid container>
                <Grid item xs={5}><div style={{width:'calc(100% - 60px)'}}><Text variant='outlined' size='small' title='Delay in seconds' name='seconds_delay' type='number' min={0} max={600}/></div></Grid>
                <Grid item xs={7}><Typography variant='caption' style={{width:'calc(100% - 20px)'}}>Minimum allowed is 30 seconds to avoid having your email client block us or flag your account.</Typography></Grid>
                <Grid item xs={12}><hr/></Grid>
              </Grid>
            </Grid>
          </Grid>
          </div>
        }/>
        </form>
      )}
    </Form>
  );
}


export default connect(ss, dd)(Sending_limits_update_popup);

function ss(state){
  return{}
}

function dd(dispatch){
  return{
  }
}
